<template>
  <div class="l-container Mypage">

    <div class="wrapper1">
      <div class="oshirase">oshirase</div>
    </div>

    <div class="wrapper2">
      <div class="memo">memo</div>
      <div class="user" @click="zoom('zoomUser')" v-bind:class="{ 'active': zoomUser }">
        <ul>
          <li>user: {{user.user}}</li>
          <li>name: {{user.name}}</li>
          <li>email: {{user.email}}</li>
          <li>type: {{user.type}}</li>
          <li>img: {{user.img}}</li>
        </ul>
      </div>
    </div>

    <div class="wrapper3">
      <div class="todo">
        todo
        <ul v-for="(list, index) in todos" :key="index">
          <li>{{list.id}}</li>
          <li>{{list.user_id}}</li>
          <li>{{list.state}}</li>
          <li>{{list.note}}</li>
          <li>{{list.created_at}}</li>
          <li>{{list.updated_at}}</li>
        </ul>
      </div>
      <div class="data">data</div>
    </div>

  </div>
</template>

<script>
export default {
  props: {
  },
  computed: {
    user () {
      return this.$store.getters.user
    },
    todos () {
      return this.$store.getters.todos
    },
    filteredTodos () {
      return this.todos.filter((todo) => {
        return todo.user_id === this.user.id
      })
    }
  },
  data () {
    return {
      zoomOshirase: false,
      zoomMemo: false,
      zoomUser: false,
      zoomTodo: false,
      zoomData: false,
      todo: {
        state: '',
        note: ''
      }
    }
  },
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  methods: {
    zoom (col) {
      console.log(col)
      // this[col] = !this[col]
      this.zoomOshirase = false
      this.zoomMemo = false
      this.zoomUser = true
      this.zoomTodo = false
      this.zoomData = false
    }
  },
  route: {
  },
  mounted () {
  }
}
</script>

<style lang="scss">
.Mypage {
  .multiselect__tags {
    padding: 0 40px 0 0;
    min-height: initial;
  }
}
</style>
<style lang="scss" scoped>
.table {
  margin-top: 0 !important;
}
.th, .td {
  padding: 0.5rem 0.5rem !important;
  border-right: solid 1px #ccc;
}
.th {
  cursor: pointer;
}
input {
  width: 100%;
  min-width: 100px;
  height: 100%;
  padding: 0;
  outline: 0;
  border: none;
}
.active {
  color: red;
  /* position: absolute; */
  /* top: 10px; */
  width: 100%;
  /* height: calc(100% - 20px); */
}
.l-container {
  /* position: relative; */
  padding: 10px 0;
  display: flex;
  flex-flow: column;
  height: calc(100vh - 80px);
  .wrapper1 {
    flex: 1;
    .oshirase {
      height: 100%;
      padding: 5px;
      background: #cdeeff;
      transition: 1s all ease 0s;
    }
  }
  .wrapper2 {
    flex: 1;
    display: flex;
    flex-flow: row;
    .memo {
      flex: 3;
      padding: 5px;
      background: #dffbef;
      transition: 1s all ease 0s;
    }
    .user {
      flex: 2;
      padding: 5px;
      background: #fae7ed;
      transition: 1s all ease 0s;
    }
  }
  .wrapper3 {
    flex: 1;
    display: flex;
    flex-flow: row;
    .todo {
      flex: 2;
      padding: 5px;
      background: #faf8e7;
      transition: 1s all ease 0s;
    }
    .data {
      flex: 3;
      padding: 5px;
      background: #faf0e7;
      transition: 1s all ease 0s;
    }
  }
}
</style>



// WEBPACK FOOTER //
// Mypage.vue?391f60c6